var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Pressable, Stack, Text } from "native-base";
import { useLinking } from "../providers/routing";
import Badge from "../atoms/Badge";
export const Tab = ({ route, params, title, badge, _tab, }) => {
    const _a = useLinking(route, params), { isActive } = _a, linkProps = __rest(_a, ["isActive"]);
    return (_jsx(Pressable, Object.assign({}, (isActive
        ? {
            borderBottomColor: "green.600",
            borderBottomStyle: "solid",
            borderBottomWidth: 2,
        }
        : undefined), { p: 2, fontSize: "md" }, _tab, linkProps, { children: _jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", space: 1 }, { children: [_jsx(Text, Object.assign({ fontWeight: "medium", color: isActive ? "green.600" : "gray.600" }, { children: title })), badge && (_jsx(Badge, Object.assign({ variant: isActive ? "ghostSuccess" : "ghost", hasIndicator: false }, { children: badge })))] })) })));
};
const RoutableTabsBreaking = (_a) => {
    var { tabs, size = "sm", _tab } = _a, rest = __rest(_a, ["tabs", "size", "_tab"]);
    if (!tabs.length) {
        return null;
    }
    return (_jsx(Box, Object.assign({ testID: "tabs" }, { children: _jsx(Stack, Object.assign({ direction: "row", 
            //space={2}
            width: "full", flexWrap: "wrap", justifyContent: "flex-start" }, rest, { children: tabs.map((tab, tabIndex) => (_jsx(Tab, { size: size, title: tab.title, route: tab.route, params: tab.params, badge: tab.badge, _tab: _tab }, `tab-item-${tabIndex}`))) })) })));
};
export default RoutableTabsBreaking;
